import type { SheetPileSectionItem } from '@/types/components'

export const SHEET_PILE_SECTIONS: SheetPileSectionItem[] = [
  // Row 1
  {
    id: 30006300000000,
    name: 'PZ 27',
    imageUrl: '/images/banners/panels/sheet.z.pz.png',
    linkUrl: '/panels/30006300000000',
  },
  {
    id: 30085700000000,
    name: 'Z-Pile CF® 16-2146',
    imageUrl: '/images/banners/panels/sheet.uzua.cf.png',
    linkUrl: '/panels/30085700000000',
  },
  {
    id: 50820908209022,
    name: 'O-Pile® 13-308',
    imageUrl: '/images/banners/panels/pipe_only.wom_wof_xl.png',
    linkUrl: '/panels/50820908209022',
  },
  {
    id: 4,
    name: 'OZ HR® 78-3638',
    imageUrl: '/images/banners/panels/single_pipe.c9-xxl.png',
    linkUrl: '/panels/40826800427115',
  },
  // Row 2
  {
    id: 30003300000000,
    name: 'PZC 18',
    imageUrl: '/images/banners/panels/sheet.z.pz.png',
    linkUrl: '/panels/30003300000000',
  },
  {
    id: 30085800000000,
    name: 'Z-Pile CF® 18-2146',
    imageUrl: '/images/banners/panels/sheet.uzua.cf.png',
    linkUrl: '/panels/30085800000000',
  },
  {
    id: 50020100201022,
    name: 'O-Pile® 165-1283',
    imageUrl: '/images/banners/panels/pipe_only.wom_wof_xl.png',
    linkUrl: '/panels/50020100201022',
  },
  {
    id: 40014100030080,
    name: 'OZ BNS® 73-2699',
    imageUrl: '/images/banners/panels/single_pipe.wom_wof_xl.png',
    linkUrl: '/panels/40014100030080',
  },
  // Row 3
  {
    id: 30037500000000,
    name: 'AZ 27-800',
    imageUrl: '/images/banners/panels/sheet.z.az.png',
    linkUrl: '/panels/30037500000000',
  },
  {
    id: 30082100000000,
    name: 'Z-Pile HR® 21-2010',
    imageUrl: '/images/banners/panels/sheet.uzua.az.png',
    linkUrl: '/panels/30082100000000',
  },
  {
    id: 50025500255042,
    name: 'O-Pile® 92-1575',
    imageUrl: '/images/banners/panels/pipe_only.wom_wof_xl.png',
    linkUrl: '/panels/50025500255042',
  },
  {
    id: 10003400425158,
    name: 'IZ® HR® 82-2473',
    imageUrl: '/images/banners/panels/single_beam.w.az.png',
    linkUrl: '/panels/10003400425158',
  },
  // Row 4
  {
    id: 13,
    name: 'NZ 42',
    imageUrl: '/images/banners/panels/sheet.z.az.arr.png',
    linkUrl: '/panels/30090400000000',
  },
  {
    id: 30082500000000,
    name: 'Z-Pile HR® 42-2010',
    imageUrl: '/images/banners/panels/sheet.uzua.az.png',
    linkUrl: '/panels/30082500000000',
  },
  {
    id: 50014100141022,
    name: 'O-Pile® 177-1080',
    imageUrl: '/images/banners/panels/pipe_only.wom_wof_xl.png',
    linkUrl: '/panels/50014100141022',
  },
  {
    id: 80042300000000,
    name: 'I-Pile® 186-688',
    imageUrl: '/images/banners/panels/single_beam_only.ihr_d.png',
    linkUrl: '/panels/80042300000000',
  },
]
